export const REGISTER_API_URL = "/register";

export const LOGIN_API_URL = "/login";
export const FORGET_PASSWORD_API_URL = "/forget-password";
export const RESET_PASSWORD_API_URL = "/reset-password";
export const RESET_PASSWORD_VALUE_API_URL = "/resetPassword";
export const CHANGE_PASSWORD_VALUE_API_URL = "/change-password";
export const VERIFY_EMAIL_OTP_API_URL = "/verify-change-email";
export const VERIFY_OTP_API_URL = "/verify-otp";
export const RESEND_OTP_API_URL = "/resend-otp";
export const VERIFY_FORGOT_OTP_API_URL = "/verify-forget-password";
export const RESEND_FORGOT_OTP_API_URL = "/reset-resend-otp";

export const ME_API_URL = "/users/me";
export const UPDATE_USER_URL = "/update-profile";

export const UPLOAD_ATTACHMENT_URL = "/presigned-upload";

export const USER_LIST = "/users/get_creators";
export const CHAT_URL = "/chats/";
export const GET_CHAT_STARTERS = "/chats/starters";
export const GET_CHAT_MESSAGES = (chat_id) => `/chats/${chat_id}/messages`;
export const DELETE_CHAT_MESSAGES = (chat_id) => `/chats/${chat_id}`;
export const GET_CREATOR_DETAILS = (user_id) => `/users/${user_id}`;
export const GET_SUBSCRIPTION_PLANS = (creator_id, planType = 'subscription') =>
    `/subscription-plans/?creator_id=${creator_id}&plan_type=${planType}`;
export const GET_MESSAGE_LIMITS = (creator_id) => `/subscriptions/limits?creator_id=${creator_id}`;
export const CREATE_CHECKOUT_SESSION = "/subscription-plans/create-checkout-session";
export const CONFIRM_CHECKOUT_SESSION = "/subscription-plans/confirm-checkout-session";
export const CUSTOMER_PORTAL_URL = "/subscription-plans/customer-portal-url";
export const GET_SUBSCRIPTION_DETAILS = (plan_id) => `/subscription-plans/plan/${plan_id}`;
export const GET_PUBLIC_PROFILE_URL = (username) => `/users/profile/${username}`;
export const ANONYMOUS_SESSION_URL = "/anonymous-sessions";
export const FUNNEL_ASSIGNMENT_URL = "/anonymous-sessions/assignment";
export const GET_SUBSCRIBED_CREATOR = "/subscriptions/";
export const GET_SUBSCRIBED_CREATOR_BY_ID = (creator_id) => `/subscriptions/by-creator/${creator_id}`;
export const GET_INVOICES_BY_SUBSCRIPTION = (subscription_id, limit) => `/subscriptions/${subscription_id}/invoices?limit=${limit}`;
export const CHANGE_PAYMENT_METHOD_BY_ID = (subscription_id) => `/subscriptions/${subscription_id}/payment-method/portal-session`;
export const CANCEL_SUBSCRIPTION_BY_ID = (subscription_id) => `/subscriptions/${subscription_id}/cancel`;
export const RESUME_SUBSCRIPTION_BY_ID = (subscription_id) => `/subscriptions/${subscription_id}/resume`;

export const FEEDBACK_URL = "/feedback/";


